// import React from 'react'
// import { Divider } from 'antd'
// import { Toolbar } from 'gg-editor'
// import ToolbarButton from './ToolbarButton'
// import styles from './index.scss'

// const FlowToolbar = () => {
//   return (
//     <Toolbar className='toolbar'>
//       <ToolbarButton command="undo" />
//       <ToolbarButton command="redo" />
//       <Divider type="vertical" />
//       <ToolbarButton command="copy" />
//       <ToolbarButton command="paste" />
//       <ToolbarButton command="delete" />
//       <Divider type="vertical" />
//       <ToolbarButton command="zoomIn" icon="zoom-in" text="Zoom In" />
//       <ToolbarButton command="zoomOut" icon="zoom-out" text="Zoom Out" />
//       <ToolbarButton command="autoZoom" icon="fit-map" text="Fit Map" />
//       <ToolbarButton command="resetZoom" icon="actual-size" text="Actual Size" />
//       <Divider type="vertical" />
//       <ToolbarButton command="toBack" icon="to-back" text="To Back" />
//       <ToolbarButton command="toFront" icon="to-front" text="To Front" />
//       <Divider type="vertical" />
//       <ToolbarButton command="multiSelect" icon="multi-select" text="Multi Select" />
//       <ToolbarButton command="addGroup" icon="group" text="Add Group" />
//       <ToolbarButton command="unGroup" icon="ungroup" text="Ungroup" />
//     </Toolbar>
//   )
// }

// export default FlowToolbar

import React from 'react'
import { Divider } from 'antd'
import { Toolbar } from 'gg-editor'
import ToolbarButton from './ToolbarButton'
import styles from './index.scss'
import { Row, Col } from 'antd'
import { UnorderedListOutlined } from '@ant-design/icons'

const FlowToolbar = (props) => {
  return (
    <Toolbar>
      <Row
        style={{
          backgroundColor: '#3288D8',
          paddingTop: 19,
          paddingBottom: 13,
          paddingLeft: 132,
          borderTopRightRadius: '8px',
        }}
      >
        {/* <ToolbarButton command="undo" />
        <div style={{ paddingLeft: 26.5 }}>
          <ToolbarButton command="redo" />
        </div> */}
        {/* <Divider type="vertical" /> */}
        {/* <div style={{ paddingLeft: 26.5 }}>
          <ToolbarButton command="copy" />
        </div>
        <ToolbarButton command="paste" />
        <div style={{ paddingLeft: 26.5 }}>
          <ToolbarButton command="delete" />
        </div> */}
        <div
          style={{ paddingLeft: 26.5, cursor: 'pointer' }}
          onClick={() => window.scrollTo(0, 0)}
        >
          <ToolbarButton command='zoomIn' />
        </div>
        <div
          style={{ paddingLeft: 26.5, cursor: 'pointer' }}
          onClick={() => window.scrollTo(0, 0)}
        >
          <ToolbarButton command='zoomOut' />
        </div>
        <div
          style={{ paddingLeft: 26.5, cursor: 'pointer' }}
          onClick={() => window.scrollTo(0, 0)}
        >
          <ToolbarButton command='autoZoom' dataChart={props.dataChart} />
        </div>
        {/* <div style={{ paddingLeft: 26.5 }}>
          <ToolbarButton command="toBack" />
        </div>
        <div style={{ paddingLeft: 26.5 }}>
          <ToolbarButton command="toFront" />
        </div>
        <div style={{ paddingLeft: 26.5 }}>
          <ToolbarButton command="multiSelect" />
        </div>
        <div style={{ paddingLeft: 26.5 }}>
          <ToolbarButton command="addGroup" />
        </div>
        <div style={{ paddingLeft: 26.5 }}>
          <ToolbarButton command="unGroup" />
        </div> */}
        {/* <div style={{ marginLeft: 620 }}>
          <h2 style={{ color: 'white' }}>
            <UnorderedListOutlined style={{ color: 'white', marginRight: 10 }} />
            List
          </h2>
        </div> */}
        {/* <Divider type="vertical" />
      <ToolbarButton command="zoomIn" icon="zoom-in" text="Zoom In" />
      <ToolbarButton command="zoomOut" icon="zoom-out" text="Zoom Out" />
      <ToolbarButton command="autoZoom" icon="fit-map" text="Fit Map" />
      <ToolbarButton command="resetZoom" icon="actual-size" text="Actual Size" />
      <Divider type="vertical" />
      <ToolbarButton command="toBack" icon="to-back" text="To Back" />
      <ToolbarButton command="toFront" icon="to-front" text="To Front" />
      <Divider type="vertical" />
      <ToolbarButton command="multiSelect" icon="multi-select" text="Multi Select" />
      <ToolbarButton command="addGroup" icon="group" text="Add Group" />
      <ToolbarButton command="unGroup" icon="ungroup" text="Ungroup" /> */}
      </Row>
    </Toolbar>
  )
}

export default FlowToolbar
